export default __webpack_public_path__ + "static/media/boy_avtar.2086a089.svg";